<template>
  <div>
    <div class="recycle">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="系统用户" name="first"></el-tab-pane>
        <el-tab-pane label="服务人员" name="second"></el-tab-pane>
        <el-tab-pane label="服务对象" name="customer"></el-tab-pane>
      </el-tabs>
      <el-form ref="elForm" inline>
        <el-form-item>
          <el-input v-model="query.name_or_phone" placeholder="请输入姓名或手机号" @keyup.enter.native="search" clearable
            style="width: 300px;margin-right: 40px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button v-if="JudgeButton(role_permission,'recycle/query')" type="primary" icon="el-icon-search"
            @click="search"> 查询 </el-button>
          <el-button v-if="JudgeButton(role_permission,'recycle/reback')" :disabled="!multipleSelection.length"
            @click="handleEdit('')" type="success" icon="el-icon-refresh-right" style="margin: 0 40px;"> 还原 </el-button>
          <el-button v-if="JudgeButton(role_permission,'recycle/delete')" :disabled="!multipleSelection.length"
            @click="handleDelete('')" type="danger" icon="el-icon-milk-tea"> 删除 </el-button>
        </el-form-item>
      </el-form>
      <div v-loading='loading' style="width: 85%">
        <!-- 系统用户 -->
        <el-table stripe border :data="list" v-if="activeName == 'first'" @selection-change="handleSelectionChange">
          <el-table-column align='center' type="selection" width="55"></el-table-column>
          <el-table-column align='center' prop="name" label="姓名" width="180"></el-table-column>
          <el-table-column align='center' label="性别" width="80">
            <template slot-scope="scope">
              {{scope.row.sex | isSex }}
            </template>
          </el-table-column>
          <el-table-column align='center' prop="phone" label="手机号"></el-table-column>
          <el-table-column align='center' prop="role_name" label="角色"></el-table-column>
          <el-table-column align='center' prop="area_name" label="区域"></el-table-column>
          <el-table-column align='center' label="操作" width="180">
            <template slot-scope="scope">
              <el-button v-if="JudgeButton(role_permission,'recycle/reback')" size="mini"
                @click="handleEdit(scope.row.uid)">还原</el-button>
              <el-button v-if="JudgeButton(role_permission,'recycle/delete')" size="mini" type="danger"
                @click="handleDelete(scope.row.uid)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 服务人员 -->
        <el-table stripe border :data="list" v-if="activeName == 'second'" @selection-change="handleSelectionChange">
          <el-table-column align='center' type="selection" width="55"></el-table-column>
          <el-table-column align='center' prop="user_name" label="姓名" width="180"></el-table-column>
          <el-table-column align='center' label="性别" width="80">
            <template slot-scope="scope">
              {{scope.row.user_sex | isSex }}
            </template>
          </el-table-column>
          <el-table-column align='center' prop="user_phone" label="手机号"></el-table-column>
          <el-table-column align='center' prop="add_time" label="创建(注册)时间"></el-table-column>
          <el-table-column align='center' prop="user_area_name" label="区域"></el-table-column>
          <el-table-column align='center' label="操作" width="180">
            <template slot-scope="scope">
              <el-button v-if="JudgeButton(role_permission,'recycle/reback')" size="mini"
                @click="handleEdit(scope.row.user_id)">还原</el-button>
              <el-button v-if="JudgeButton(role_permission,'recycle/delete')" size="mini" type="danger"
                @click="handleDelete(scope.row.user_id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 服务对象 -->
        <el-table stripe border :data="list" v-if="activeName == 'customer'" @selection-change="handleSelectionChange">
          <el-table-column align='center' type="selection" width="55"></el-table-column>
          <el-table-column align='center' prop="customer_name" label="姓名" width="80"></el-table-column>
          <el-table-column align='center' label="性别" width="80">
            <template slot-scope="scope">
              {{scope.row.customer_sex | isSex }}
            </template>
          </el-table-column>
          <el-table-column align='center' prop="customer_age" label="年龄" width="80"></el-table-column>
          <el-table-column align='center' prop="customer_phone" label="手机号" width="150"></el-table-column>
          <el-table-column align='center' prop="customer_current_address" label="现居住地址" show-overflow-tooltip>
          </el-table-column>
          <el-table-column align='center' label="重要程度" width="100">
            <template slot-scope="scope">
              <span
                :class="'state-'+scope.row.customer_important_degree">{{ scope.row.customer_important_degree | isImportant }}</span>
            </template>
          </el-table-column>
          <el-table-column align='center' prop="founders" label="创建人" width="100"></el-table-column>
          <el-table-column align='center' prop="add_time" label="创建时间" width="180"></el-table-column>
          <el-table-column align='center' prop="customer_area_name" label="区域"></el-table-column>
          <el-table-column align='center' label="操作" width="180">
            <template slot-scope="scope">
              <el-button v-if="JudgeButton(role_permission,'recycle/reback')" size="mini"
                @click="handleEdit(scope.row.customer_id)">还原</el-button>
              <el-button v-if="JudgeButton(role_permission,'recycle/delete')" size="mini" type="danger"
                @click="handleDelete(scope.row.customer_id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="margin: 30px auto;text-align: center;" v-if="query.total > 0"
          @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="query.page_limit" layout="total, sizes, prev, pager, next, jumper"
          :total="query.total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import userInfoAPI from '@/api/api';
  export default {
    name: 'index',
    components: {
    },
    data() {
      return {
        activeName: 'first',
        loading: true,
        query: {
          name_or_phone: '',
          flag: 1, // 标识 1=系统用户 2=服务人员 3=服务对象
          page_limit: 10,
          page: 1,
          total: 0
        },
        list: [],
        multipleSelection: [],
      }
    },
    computed: {
      name() {
        if (this.activeName == 'first') return name = '用户'
        if (this.activeName == 'second') return name = '人员'
        if (this.activeName == 'customer') return name = '服务对象'
      },
      ids() {
        if (this.activeName == 'first') return this.multipleSelection.map(i => {
          return i.uid
        })
        if (this.activeName == 'second') return this.multipleSelection.map(i => {
          return i.user_id
        })
        if (this.activeName == 'customer') return this.multipleSelection.map(i => {
          return i.customer_id
        })
      },
      role_permission() {
        return this.$store.getters.role_permission
      }
    },
    mounted() {
      if (this.$store.state.cache.cacheRestoreQuery) {
        this.query = this.$store.state.cache.cacheRestoreQuery
        if (this.query.activeName) this.activeName = this.query.activeName
      }
      this.getList()
    },
    beforeDestroy() {
      this.$store.commit('CACHE_RESTORE', Object.assign(this.query, {
        activeName: this.activeName
      }))
    },
    methods: {
      JudgeButton(list, rot) {
        let fal = false;
        list.forEach((i, l) => {
          if (i.path == rot) {
            return fal = true;
          }
        })
        return fal
      },
      search() {
        this.loading = true;
        this.query.page = 1;
        this.getList()
      },
      handleSizeChange(val) {
        this.loading = true
        this.query.page_limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.loading = true
        this.query.page = val;
        this.getList();
      },
      getList() {
        this.loading = true
        userInfoAPI.recycleList(this.query).then(res => {
          if (res.data.code == 0) {
            this.list = res.data.data.list || []
            this.query.total = res.data.data.page.count || 0
          }
          this.loading = false
        })
      },
      handleClick(tab, event) {
        this.activeName = tab.name
        this.loading = true
        this.list = []
        this.query.name_or_phone = ''
        this.query.flag = parseInt(tab.index) + 1
        this.query.total = 0
        this.query.page = 1
        this.getList()
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      handleEdit(id) {
        var ids = ''
        if (id) ids = id
        else ids = this.ids.join(',')
        this.$confirm('是否确定恢复该' + this.name + '以及相关权限?', '温馨提示', {
          confirmButtonText: '还原',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          userInfoAPI.recycleBack({
            flag: this.query.flag,
            key_id: ids
          }).then((res) => {
            if (res.data.code == 0) {
              this.getList()
              this.$message({
                type: 'success',
                message: '还原成功!'
              })
            } else {
              this.$message({
                type: 'error',
                message: res.data.msg
              })
            }
          })
        })
      },
      handleDelete(id) {
        var ids = ''
        if (id) ids = id
        else ids = this.ids.join(',')
        this.$confirm('此操作将永久删除该' + this.name + ', 是否继续?', '删除提醒', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          userInfoAPI.recycleDel({
            flag: this.query.flag,
            key_id: ids
          }).then((res) => {
            if (res.data.code == 0) {
              this.getList()
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            } else {
              this.$message({
                type: 'error',
                message: res.data.msg
              })
            }
          })
        })
      },
    }
  }
</script>
<style lang='scss' scoped>
  /deep/.el-tabs__nav-wrap::after {
    position: static !important;
  }

  .recycle {
    margin: 10px 30px 0 30px;
  }

  .state-2 {
    color: #e4be44;
  }

  .state-3 {
    color: red;
  }
</style>
